import type { TeamsSchema } from "@/hooks/roster-craete/useTeamsQuery";
import { sortTeamsByName } from "@/utils/team-sort-util";

export function groupIssuedRosterTeams<T extends { nurse_id: string }>(
  teams: TeamsSchema,
  nurses: readonly T[]
): { team_id: number | null; team_name: string; nurses: T[] }[] {
  const teamByNurseId = new Map<string, number>();
  for (const team of teams) {
    for (const nurseId of team.team_members) {
      teamByNurseId.set(nurseId, team.team_id);
    }
  }
  return [
    ...sortTeamsByName(teams).map(team => ({
      team_id: team.team_id,
      team_name: team.team_name,
      nurses: nurses.filter(nurse => teamByNurseId.get(nurse.nurse_id) === team.team_id),
    })),
    {
      team_id: null,
      team_name: "미등록",
      nurses: nurses.filter(nurse => !teamByNurseId.has(nurse.nurse_id)),
    },
  ];
}
